// extracted by mini-css-extract-plugin
module.exports = {"container":"_GshCMAs5l-II8_cKvtzn"};